import { StyledComponent } from '@emotion/styled'
import { LicenseInfo } from '@mui/x-license-pro'
import { ReactElement } from 'react'

import { isStatusSeverity } from '../components/Status'
// import { RefObject } from 'react'

export type E2eTag = { 'data-test-id'?: string }
// export type Ref = ((instance: HTMLInputElement | null) => void) | RefObject<HTMLInputElement> | null | undefined
// export type OptEntry = { label: string; value: string }
export type MsdkStyledComponent<T> = StyledComponent<T & E2eTag>
export type MsdkComponent = ReactElement & E2eTag

export interface OptionItem {
  value: string
  label: string
  color?: string
  parentId?: string
  parentLabel?: string
  icon?: string
  disabled?: boolean
  rightLabel?: string
}

export const findDuplicates = (arr: string[]) => arr.filter((item, index) => arr.indexOf(item) !== index)

export const validateUILicense = (key: string) => {
  LicenseInfo.setLicenseKey(key ?? '')
}

export const computeStatusPropsFromOptionItem = (opt?: Partial<{ fontColor: string; icon: string }>) => {
  const severity = opt?.fontColor && isStatusSeverity(opt.fontColor) ? opt.fontColor : undefined
  const color = severity ? undefined : opt?.fontColor ? opt.fontColor : 'inherit'
  const icon = opt?.icon ? (opt.icon === 'false' ? undefined : opt.icon) : undefined
  const disableFallbackIcon = !severity || opt?.icon === 'false'

  return {
    severity,
    color,
    icon,
    disableFallbackIcon,
  }
}
